import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rkstest',
  templateUrl: './rkstest.component.html',
  styleUrls: ['./rkstest.component.css']
})
export class RkstestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
